// extracted by mini-css-extract-plugin
var _1 = "ProfileInfoWidgetItem-moduleProfileInfoWidgetItem__mLc78";
var _2 = "ProfileInfoWidgetItem-modulecopyButton__zdayZ";
var _3 = "ProfileInfoWidgetItem-moduleplaceholder__fxgPc ProfileInfoWidgetItemValue-moduletext__QCmBO";
var _4 = "ProfileInfoWidgetItem-moduletitle__JZCgW";
var _5 = "ProfileInfoWidgetItem-modulevalue__aQPIl";
var _6 = "ProfileInfoWidgetItem-modulevalueCopyable__nFSsQ";
export { _1 as "ProfileInfoWidgetItem", _2 as "copyButton", _3 as "placeholder", _4 as "title", _5 as "value", _6 as "valueCopyable" }
